<button
    [ngClass]="[
        disabled ? 'disabled' : '',
        stretch,
        variant
    ]"
    [ngStyle]="buttonStyles | theme"
    [disabled]="disabled"
    (click)="onClick()"
>
    <ng-container *ngIf="icon && (iconPosition === 'left') && !loading">
        <span [ngStyle]="iconStyles | theme">
            <ng-container *ngTemplateOutlet="iconTemplate"></ng-container>
        </span>
    </ng-container>

    <span 
        *ngIf="!loading"
        [ngStyle]="labelStyles | theme">
        {{ label }}
    </span>

    <ng-container *ngIf="icon && iconPosition === 'right' && !loading">
        <span [ngStyle]="iconStyles | theme">
            <ng-container *ngTemplateOutlet="iconTemplate"></ng-container>
        </span>
    </ng-container>

    <ng-template #iconTemplate>
        <app-icon
            *ngIf="icon && !loading"
            [icon]="icon"
            [colorCss]="variant === 'primary' ? '--button-action-primary-icon-fill' : '--button-action-secondary-icon-fill'" 
            sizeCss="--icon-medium">
        </app-icon>
    </ng-template>

    <ion-spinner 
        *ngIf="loading" 
        name="crescent" 
        [ngStyle]="spinnerStyles | theme"
        class="spinner"/>
</button>
